// AUTO-GENERATED by scripts/write-build-token.mjs at build time. Do not edit.
export const BUILD_TOKEN = 'c2204a2c5630';
